import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { SvgIcon } from '@common/sprites';
import classes from './classes.module.scss';
import { separateThousands } from '../../../../config/util';
import ExpandedText from '../../../../../common/helpers/expanded_text';

function ReadingSinceAndCountItem({
  readingsCount,
  yearJoined,
  t,
  theme,
  loading,
  isNewAdvisor,
  plain = false
}) {
  const renderInner = () => (isNewAdvisor ? (
    <span className={ classes.newlyVettedInlineRow } suppressHydrationWarning>
      <SvgIcon id="new_advisor" size={ 20 } className={ classes.newlyVettedIcon } suppressHydrationWarning />
      <span className={ classes.newlyVettedText } suppressHydrationWarning>
        {t('home_page.newly_vetted')}
      </span>
    </span>
  ) : (
    <>
      <span className={ classes.countContainer } suppressHydrationWarning data-testid="readings-count">
        {separateThousands(readingsCount)}
      </span>
      <span className={ classes.readingsSinceContainer } suppressHydrationWarning data-testid="year-joined">
        {t('home_page.readings_since')}
        <span suppressHydrationWarning>
          {` ${ yearJoined || '' }`}
        </span>
      </span>
      <span className={ classes.readingsSinceMobileContainer } suppressHydrationWarning>
        {t('home_page.readings_since_mobile')}
        <span suppressHydrationWarning>
          {` (${ yearJoined || '' })`}
        </span>
      </span>
    </>
  ));

  const renderContent = () => {
    if (loading) return <Skeleton width={ 170 } />;
    if (plain) {
      return (
        <div className={ classes[theme] } suppressHydrationWarning>
          {renderInner()}
        </div>
      );
    }
    return (
      <ExpandedText ellipsis limit={ 2 } className={ classes[theme] } textStyle={ { wordBreak: 'initial' } }>
        {renderInner()}
      </ExpandedText>
    );
  };
  return renderContent();
}

export default ReadingSinceAndCountItem;
